import utils from "./utils";

export default class AssetReservation {
  constructor(api) {
    this.api = api;
  }

  getAll(fieldsToAppend, workspaceUUID, includeDeleted, onSuccess, onError) {
    let headers;
    if (workspaceUUID || includeDeleted) {
      headers = { headers: {} };
      if (workspaceUUID) headers.headers.workspaceuuid = workspaceUUID;
      if (includeDeleted) headers.headers["include-deleted"] = includeDeleted;
    }

    return this.api.http_fibercloud
      .get(
        "v1/asset-reservations/" +
          (fieldsToAppend ? "?append=" + fieldsToAppend : ""),
        headers
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTemplates(appends, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/asset-reservation-templates/" +
          (appends ? "?append=" + appends : "")
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTemplateByUUID(templateUUID, appends, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/asset-reservation-templates/" +
          templateUUID +
          (appends ? "?append=" + appends : "")
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createTemplate(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/asset-reservation-templates", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateTemplate(uuid, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("v1/asset-reservation-templates/" + uuid, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteTemplate(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/asset-reservation-templates/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/asset-reservations-bulk", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  update(uuid, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("v1/asset-reservations/" + uuid, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createAssetReservationObject(assetReservationUUID, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/asset-reservations/" + assetReservationUUID + "/objects", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateAssetReservationObject(
    assetReservationUUID,
    objectUUID,
    data,
    onSuccess,
    onError
  ) {
    return this.api.http_fibercloud
      .patch(
        "v1/asset-reservations/" +
          assetReservationUUID +
          "/objects/" +
          objectUUID,
        data
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteAssetReservationObject(
    assetReservationUUID,
    objectUUID,
    onSuccess,
    onError
  ) {
    return this.api.http_fibercloud
      .delete(
        "v1/asset-reservations/" +
          assetReservationUUID +
          "/objects/" +
          objectUUID
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAssetReservationsByObject(objectEndpoint, objectUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/" + objectEndpoint + "/" + objectUUID + "/asset-reservations", {
        headers: utils.getHeaders()
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAssociatedObjectByUuid(
    assetReservationUuid,
    objectUUID,
    fieldsToAppend,
    onSuccess,
    onError
  ) {
    return this.api.http_fibercloud
      .get(
        "v1/asset-reservations/" +
          assetReservationUuid +
          "/objects/" +
          objectUUID +
          (fieldsToAppend ? "?append=" + fieldsToAppend : ""),
        {
          headers: utils.getHeaders()
        }
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/assetReservation.js